import axiosInstance from '../../../lib/axios';

class AppVersionService {
  // Récupérer toutes les versions des deux plateformes
  async getAllVersions() {
    try {
      const response = await axiosInstance.get('/api/v1/app-versions/all');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des versions:', error);
      throw error;
    }
  }

  // Vérifier la version (utilisé par les apps mobiles)
  async checkVersion(platform) {
    try {
      const response = await axiosInstance.get('/api/v1/app-version/check', {
        params: { platform }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la vérification de version:', error);
      throw error;
    }
  }

  // Créer ou mettre à jour une version (Admin)
  async updateVersion(versionData) {
    try {
      const response = await axiosInstance.post('/api/v1/admin/app-version', versionData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de version:', error);
      throw error;
    }
  }

  // Récupérer l'historique des versions pour une plateforme
  async getVersionHistory(platform, page = 1, limit = 10) {
    try {
      const response = await axiosInstance.get(`/api/v1/admin/app-versions/${platform}/history`, {
        params: { page, limit }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'historique:', error);
      throw error;
    }
  }

  // Activer/désactiver une version
  async toggleVersionStatus(platform, versionId, isActive) {
    try {
      const response = await axiosInstance.patch(`/api/v1/admin/app-versions/${platform}/${versionId}/status`, {
        is_active: isActive
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors du changement de statut:', error);
      throw error;
    }
  }

  // Supprimer une version (si nécessaire)
  async deleteVersion(platform, versionId) {
    try {
      const response = await axiosInstance.delete(`/api/v1/admin/app-versions/${platform}/${versionId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      throw error;
    }
  }

  // Valider le format de version (utilitaire côté client)
  validateVersionFormat(version) {
    const versionRegex = /^\d+\.\d+\.\d+$/;
    return versionRegex.test(version);
  }

  // Comparer deux versions (utilitaire côté client)
  compareVersions(version1, version2) {
    const v1Parts = version1.split('.').map(Number);
    const v2Parts = version2.split('.').map(Number);

    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
      const v1Part = v1Parts[i] || 0;
      const v2Part = v2Parts[i] || 0;

      if (v1Part > v2Part) return 1;
      if (v1Part < v2Part) return -1;
    }
    return 0;
  }
}

export const appVersionService = new AppVersionService();